import { render, staticRenderFns } from "./ui-timeline.vue?vue&type=template&id=91512350&scoped=true"
import script from "./ui-timeline.vue?vue&type=script&lang=js"
export * from "./ui-timeline.vue?vue&type=script&lang=js"
import style0 from "./ui-timeline.vue?vue&type=style&index=0&id=91512350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91512350",
  null
  
)

export default component.exports